import { render, staticRenderFns } from "./Monitoring.vue?vue&type=template&id=0d084fe5&scoped=true"
import script from "./Monitoring.vue?vue&type=script&lang=ts"
export * from "./Monitoring.vue?vue&type=script&lang=ts"
import style0 from "./Monitoring.vue?vue&type=style&index=0&id=0d084fe5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d084fe5",
  null
  
)

export default component.exports